<template>
  <el-dialog
    title="已完成"
    :visible.sync="show"
    width="45%"
    :append-to-body="true"
    @open="handleOpen"
    :modal-append-to-body="false"
    destroy-on-close
    @closed="handleClose"
    class="completed"
    :close-on-click-modal="false"
  >
    <el-table  style="width: 100%" :data="data"
               :row-key='getRowKeys'
               :row-class-name="rowClassName"
    >
      <el-table-column label="时间" show-overflow-tooltip>
        <template slot-scope="{row}">
          {{ row.created_at|parseTime}}
        </template>
      </el-table-column>
      <el-table-column label="昵称" prop="user_name">
      </el-table-column>
      <el-table-column label="文件" prop="name" show-overflow-tooltip>
        <template slot-scope="{row}">
          <ul v-if="row.url!=''" @click="previewWord({type:row.type,url:row.url,id:row.id})" class="el-upload-list el-upload-list--text">
            <li tabindex="0" class="el-upload-list__item is-success">
              <a class="el-upload-list__item-name">
                <i class="el-icon -document"></i>
                {{row.name}}
              </a>
            </li>
          </ul>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="{row}">
          <el-button plain type="primary" @click="downLoad(row)" icon="el-icon-download" size="mini"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <axj-file-preview
      :show-preview.sync="preview.show"
      :preview-file-type="preview.previewFileType"
      :preview-files="preview.previewFiles"
    />
  </el-dialog>
</template>

<script>
import commonModels from '@/common/models/common-models'
export default {
  name: "completed",
  props:{
    showCompleted:{
      type:Boolean,
      default:false
    },
    data:{
      type:Array,
      default:()=>{}
    }
  },
  data(){
    return{
      show:false,
      preview:{
        show:false,
        previewFileType:'word',
        previewFiles:[]
      }
    }
  },
  watch:{
    showCompleted(v){
      this.show=v
    }
  },
  filters:{
    parseTime(time){
      return commonModels.formatTime(time,'Y/M/D h:m:s')
    },
  },
  computed:{
    preViewUrl(){
      return this.$common.SystemConfig.PreViewUrl
    }
  },
  methods:{
    getRowKeys(row){
      return row.id
    },
    rowClassName({row, rowIndex}){
        if(this.$store.getters.getViewHomeWork.indexOf(row.id)!=-1){
          return "gray-row"
        }
      return "while-row"
    },
    downLoad(x){
      this.$store.dispatch('saveViewHomeWork',x.id)
      window.open(this.preViewUrl+x.url)
    },
    previewWord(x){
      this.$store.dispatch('saveViewHomeWork',x.id)
      if(x.type!='image'&&x.type!='word'&&x.type!='png'&&x.type!='jpg'){
        window.open(this.preViewUrl+x.url)
        return
      }
      this.preview.previewFileType=x.type
      if(x.type=='png'||x.type=='jpg'){
        this.preview.previewFileType='image'
      }
      this.preview.previewFiles=[]
      this.preview.previewFiles.push({
        url:x.url
      })
      this.preview.show=true
    },
    handleOpen(){
      console.log(this.$store.getters.getViewHomeWork)
    },
    handleClose(){
      this.$emit("close")
    },
  }
}
</script>

<style slot-scope lang="scss">
.el-table .gray-row {
  background: #e8eef0;
}
.el-table .while-row {
  background: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/axj-help/axj-course/component/home-work/component/completed/index.vue